import { render } from "./CheckboxWithText.vue?vue&type=template&id=05a01abe&scoped=true"
import script from "./CheckboxWithText.vue?vue&type=script&lang=js"
export * from "./CheckboxWithText.vue?vue&type=script&lang=js"

import "./CheckboxWithText.vue?vue&type=style&index=0&id=05a01abe&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a01abe"]])

export default __exports__